import React from 'react'
import { alpha, styled, TextField } from '@mui/material'

const accessibleRed = '#D65C64'
export const SignInTextField: any = styled(TextField)`
    width: 34.2rem;
    margin-bottom: 4rem;

    // sets background of text field to transparent white
    > div {
        background: ${(props) =>
            alpha(props.theme.palette.primary.contrastText, 0.08)};
    }

    //floats text field name above input box
    .MuiInputLabel-shrink {
        margin-top: -1.6rem;
        margin-left: -1rem !important;
    }

    // Temporary for V1
    .Mui-disabled {
        text-fill-color: ${(props) =>
            props.theme.palette.primary.contrastText} !important;
    }

    // in case of error, only label, helpertext and border should be red, otherwise info.main
    > * {
        color: ${(props) =>
            props.error
                ? accessibleRed
                : props.theme.palette.primary.contrastText} !important;
        margin-left: 0 !important;
        margin-right: 0 !important;

        > * {
            color: ${(props) =>
                props.theme.palette.primary.contrastText} !important;
            border-color: ${(props) =>
                props.error
                    ? accessibleRed
                    : props.theme.palette.primary.contrastText} !important;

            > legend {
                max-width: 0;
            }
        }
    }

    ${(props) => props.theme.breakpoints.down('sm')} {
        width: 100% !important;
        margin-right: 0 !important;
    }
`

export default SignInTextField
